import { IconPermissionDenied } from '@ui/src';
import { Permission } from '../../hoc/settings/profile/types';

import cn from './profile.module.css';

const ProfilePermissions = ({ permissions }: { permissions: Permission[] }) => {
  let content;

  if (permissions && permissions.length) {
    content = permissions.map((item) => {
      const sectionPages = item.pages;

      let pagesContent;

      if (sectionPages && sectionPages.length) {
        pagesContent = sectionPages.map((page) => {
          const pageActions = page.actions;

          let actionsContent;

          if (pageActions && pageActions.length) {
            actionsContent = pageActions.map((action) => (
              <div
                className={cn.employeeProfilePermissionPageAction}
                key={action.title}
              >
                {action.title}
              </div>
            ));
          } else {
            actionsContent = (
              <div className={cn.employeeProfilePermissionPageAction}>
                Viewing
              </div>
            );
          }

          return (
            <div className={cn.employeeProfilePermissionPage} key={page.title}>
              <div className={cn.employeeProfilePermissionPageTitle}>
                {page.title}
              </div>
              <div className={cn.employeeProfilePermissionPageActions}>
                {actionsContent}
              </div>
            </div>
          );
        });
      } else {
        pagesContent = (
          <div className={cn.employeeProfilePermissionPage}>
            <div className={cn.employeeProfilePermissionPageTitle}>
              {item.title}
            </div>
            <div className={cn.employeeProfilePermissionPageActions}>
              <div className={cn.employeeProfilePermissionPageAction}>
                Viewing
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className={cn.employeeProfilePermissionWrapper} key={item.title}>
          {sectionPages && sectionPages.length > 0 && (
            <div className={cn.employeeSectionTitle}>{item.title}</div>
          )}
          {pagesContent}
        </div>
      );
    });
  } else {
    content = (
      <div className={cn.emptyPermissions}>
        <IconPermissionDenied />
        <div className={cn.emptyPermissionsTitle}>
          You do not have access to any sections
        </div>
        <div className={cn.emptyPermissionsDescrition}>
          If this is an error, contact your administrator
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={cn.employeeProfileTitle}>Permissions</div>
      {content}
    </>
  );
};

export default ProfilePermissions;
